<template lang="pug">
  .kol-list(v-loading="loading")
    .kol-list__header
      el-breadcrumb(
        separator="/"
        style="padding-bottom: 20px"
      )
        el-breadcrumb-item {{ $t('KOL列表') }}
      .kol-list__header__content
        tabs(
          :tabs="tabs.map(t => t.name)"
          :index="tabIndex"
          @change="changeTab"
          :tabCount="tabCount"
        )
        .kol-list__header__search
          el-input(
            v-model="keyword"
            :placeholder="$t('请输入关键字')"
            @keyup.enter.native="handleSearch"
          )
            el-button(
              slot="append"
              @click="handleSearch"
              style="font-weight: normal"
            ) {{ $t('搜索') }}
    .kol-list__filter__container
      span {{ $t('筛选类目') }}:
      .kol-list-filter__items
        .kol-list-filter__item(
          v-for="(item, i) in kolTypeList"
          :keu="i"
          :class="{ 'active__type': item.kol_type_id === kolTypeId }"
          @click="handleClickKolType(item)"
        ) {{ $t(item.kol_type) }}
    el-card.kol-list__content(
      shadow="never"
    )
      .kol-list__items__filter
        .price__filter
          span {{ $t('价格区间') }}
          .input__number__container
            span ￥
            input-with-commas(
              v-model="minPrice"
            )
          span -
          .input__number__container
            span ￥
            input-with-commas(
              v-model="maxPrice"
            )
          el-button(
            @click="filterKolByPrice"
            type="text"
          ) {{ $t('确认') }}
        .other__filter
          div(
            v-for="(item, index) in filterTypeList"
          )
            .other__filter__divider(v-if="index !== 0")
            span {{ $t(item.name) }}
            div
              i.iconfont.el-icon-caret-top(
                @click="filterKol(item.order_by_column, 1)"
                :class="[order_by_column === item.order_by_column && order_by_type === 1 ? 'is_active' : '' ]"
              )
              i.iconfont.el-icon-caret-bottom(
                @click="filterKol(item.order_by_column, 2)"
                :class="[order_by_column === item.order_by_column && order_by_type === 2 ? 'is_active' : '' ]"
              )
      .kol-list__items__container(v-if="kolListTableData.length !== 0")
        kol-list-item(
          v-for="(item, index) in kolListTableData"
          :key="index"
          :data="item"
          :listType="listType"
        )
      no-data(v-else)
    el-pagination(
      style="text-align: right"
      layout="prev, pager, next, jumper"
      :page-size="10"
      :total="listType === 'wechat' ? kolList.wechat_list.total_row : kolList.weibo_list.total_row"
      :current-page.sync="currentPage"
      @current-change='getKolList'
    )
</template>

<script>
import axios from 'axios'
import Tabs from '@/components/Tabs'
import db from '@/umcc/db'
import KolListItem from './components/KolListItem'
import InputWithCommas from '@/components/InputWithCommas'
import NoData from '@/components/NoData'

export default {
  components: {
    InputWithCommas,
    Tabs,
    KolListItem,
    NoData
  },
  mounted () {
    this.getKolList()
    this.getKolTypeList()
  },
  computed: {
    filterTypeList () {
      return this.listType === 'wechat' ? this.weChatfilterTypeList : this.weibofilterTypeList
    },
    isEn () {
      return db.lang === 'en'
    },
    listType () {
      return this.$store.state.kol.kolChannel
    },
    tabIndex () {
      return this.listType === 'wechat' ? 0 : 1
    },
    kolTypeList () {
      const wechatList = this.originKolTypeList.filter(i => i.kol_type_id !== 46 && i.kol_type_id !== 47 && i.kol_type_id !== 48)
      const weiboList = this.originKolTypeList.filter(i => i.kol_type_id === 46 || i.kol_type_id === 47 || i.kol_type_id === 48 || i.kol_type_id == null)
      return this.listType === 'wechat' ? wechatList : weiboList
    },
    kolListTableData () {
      return this.listType === 'wechat' ? this.kolList.wechat_list.table_data : this.kolList.weibo_list.table_data
    }
  },
  data () {
    return {
      minPrice: null,
      maxPrice: null,
      order_by_column: '',
      order_by_type: 1,
      tabCount: [],
      currentPage: 1,
      keyword: '',
      kolList: {
        wechat_list: {
          table_data: []
        },
        weibo_list: {
          table_data: []
        }
      },
      loading: false,
      tabs: [
        {
          name: '微信'
        },
        {
          name: '微博'
        }
      ],
      tableKey: 1,
      originKolTypeList: [],
      kolTypeId: null,
      weChatfilterTypeList: [
        {
          'name': '预估粉丝数',
          'order_by_column': 'fans'
        },
        {
          'name': '平均阅读数',
          'order_by_column': 'avg_views'
        },
        {
          'name': '平均点赞数',
          'order_by_column': 'avg_likes'
        },
        {
          'name': '报价',
          'order_by_column': 'price'
        }
      ],
      weibofilterTypeList: [
        {
          'name': '预估粉丝数',
          'order_by_column': 'fans'
        },
        {
          'name': '平均转发数',
          'order_by_column': 'avg_repost'
        },
        {
          'name': '平均点赞数',
          'order_by_column': 'avg_likes'
        },
        {
          'name': '报价',
          'order_by_column': 'price'
        }
      ]
    }
  },
  methods: {
    changeTab (index) {
      this.kolTypeId = null
      this.minPrice = null
      this.maxPrice = null
      this.currentPage = 1
      const listType = index === 0 ? 'wechat' : 'weibo'
      this.tableKey = Math.floor(Date.now() / 1000)
      this.$store.commit('kol/setKolChannel', listType)
      this.getKolList()
    },
    handleSearch () {
      this.order_by_column = ''
      this.order_by_type = 1
      this.currentPage = 1
      this.minPrice = null
      this.maxPrice = null
      this.kolTypeId = null
      this.getKolList()
    },
    getKolList () {
      this.loading = true
      document.querySelector('.main__layout__content').style.overflowY = 'hidden'
      axios.get('/kol/getKolList', {
        params: {
          page_number: this.currentPage,
          page_size: 10,
          keyword: this.keyword,
          order_by_column: this.order_by_column,
          order_by_type: this.order_by_type,
          kol_type_id: this.kolTypeId,
          min_price: this.minPrice,
          max_price: this.maxPrice
        }
      })
        .then(res => {
          document.querySelector('.main__layout__content').style.overflowY = 'auto'
          this.loading = false
          this.kolList = res
          if (this.keyword !== '') {
            this.tabCount = [res.wechat_list.total_row, res.weibo_list.total_row]
          } else {
            this.tabCount = []
          }
          // if (this.kolList.wechat_list.table_data.length === 0) {
          //   this.$store.commit('kol/setKolChannel', 'weibo')
          // } else if (this.kolList.weibo_list.table_data.length === 0) {
          //   this.$store.commit('kol/setKolChannel', 'wechat')
          // }
        })
        .catch(err => {
          document.querySelector('.main__layout__content').style.overflowY = 'auto'
          this.loading = false
          throw new Error(err)
        })
    },
    getKolTypeList () {
      axios.get('/kol/getKolTypeList')
        .then(res => {
          res.unshift({
            kol_type: '全部',
            kol_type_id: null
          })
          this.originKolTypeList = res
        })
    },
    handleClickKolType (item) {
      this.kolTypeId = item.kol_type_id
      this.getKolList()
    },
    handleChange (evt) {
      this.minPrice = this.numberWithCommas(evt)
      this.maxPrice = this.numberWithCommas(evt)
    },
    filterKol (column, type) {
      this.order_by_type = type
      this.order_by_column = column
      this.getKolList()
    },
    filterKolByPrice () {
      if (this.minPrice > this.maxPrice && this.maxPrice !== 0 && this.maxPrice != null && this.maxPrice !== '') {
        const minPrice = this.minPrice
        const maxPrice = this.maxPrice
        this.minPrice = maxPrice
        this.maxPrice = minPrice
      }
      this.getKolList()
    },
    numberWithCommas (number) {
      if (!number) return
      const n = Number(number)
      if (Number.isNaN(n)) {
        return number
      }
      return String(n).includes('.') ? String(n).split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + String(n).split('.')[1]
        : String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="stylus">
.kol-list
  min-height 100vh
.kol-list__header
  background #ffffff
  margin -16px -32px
  padding 16px 32px 0px 32px
  box-shadow  0 2px 8px 0 rgba(119, 151, 178, 0.16)
  .kol-list__header__content
    display flex
    align-items center
    justify-content space-between
  .kol-list__header__search
    padding-bottom 16px
    .el-input
      width 462px
      height 32px
      input
        height 32px
      .el-input-group__append
        width 75px
        box-sizing border-box
        text-align center
        background $main
        color #ffffff
        font-size 16px
        border-color $main
  .campaign-tab
    .el-tabs__item
      position relative
      margin-bottom 14px
      margin-top 7px
      .tab__count
        background #edf2fa
        color $main
        width 30px
        height 14px
        border-radius 7px
        display inline-block
        position absolute
        right 0
        line-height 15px
        font-size 13px
      &:nth-child(2)
        .tab__count
          right 20px
    .el-tabs__nav-wrap::after
      background-color transparent
.kol-list__content
  .el-card__body
    padding 0 !important
.kol-list
  .disabled-row
    background #d8d8d8
    .icon-heimingdan
      color #2c3031
  .caret-wrapper
    height 28px
    width 18px
    .ascending
      top 2px
      cursor pointer
    .descending
      bottom 3px
      cursor pointer
.kol-list__content__header
  display flex
  align-items flex-end
  justify-content space-between
.kol-list__items__filter
  padding 14px 32px
  border-bottom 1px solid #e8e8e8
  display flex
  justify-content space-between
  .price__filter
    display flex
    align-items center
    > span
      color $main
    .input__number__container
      margin 0 5px
      position relative
      > span
        position absolute
        z-index 10
        left 2px
        top 3px
        color #d8d8d8
      .input-with-commas
        input
          width 80px
          height 22px
          line-height 22px
          padding 0 5px 0 15px
  .el-input-number
    margin 0 8px
    width 80px
    input.el-input__inner
      border-radius 0
      height 22px
      padding 0 12px 0 15px
  .el-input-number.is-controls-right
    .el-input-number__increase,.el-input-number__decrease
      width 12px
      border-radius 0
      border-bottom none
      background #ffffff
      height 10px
    .el-input-number__increase
      top 3px
      height 10px
    .el-input-number__decrease
      bottom 3px
      height 13px
  .other__filter
    display flex
    align-items center
    > div
      display flex
      align-items center
      > div
        display flex
        flex-direction column
        .iconfont
          font-size 14px
          cursor pointer
          color #5e5e5e
          &:hover
            color $main
        .iconfont.is_active
          color $main
        .el-icon-caret-top
          margin-bottom -7px
      > span
        color #5e5e5e
    .other__filter__divider
      height 18px
      border-right 1px solid #e8e8e8
      margin 0 10px
.kol-list__filter__container
    margin-top 40px
    display flex
    > span
      min-width 80px
    .kol-list-filter__items
      display flex
      align-items center
      flex-wrap wrap
      .kol-list-filter__item
        margin-right 20px
        margin-bottom 10px
        color #999999
        cursor pointer
        font-size 12px
        height 16px
        line-height 16px
      .active__type
        color $main
  .el-pagination
    button
      background-color #f8f9fa !important
    .el-pager
      li
        background #f8f9fa
  .el-loading-mask
    .el-loading-spinner
      top 20%
</style>
